module.exports = __webpack_public_path__ + "static/pic-2@3x-1d24f156a86e30efeed6f1e69de74499.png";